<template>
  <div class="conf-container">
    <div class="conf-header flex flex--col flex--v-center">
      <div class="flex flex--col flex--v-center gap-12">
        <div class="conf-header__icon">
        <icon-rd name="check" color="light" size="sm"/>
        </div>
        <h3 class="text-20 fw-700 text--center">{{ confirmationTitle }}</h3>
        <div class="flex flex--col flex--v-center">
          <p class="text-14 fw-300 text--center">
            {{ emailTitle }}
          </p>
          <p class="text-14 fw-300 text--center">
            {{ "Please check your inbox. If you don't see it, kindly check your spam or junk folder." | translate }}
          </p>
        </div>
      </div>
    </div>
    <div class="conf-container mobile-hide">
      <p class="text-20 fw-700">{{'Booking details' | translate}}</p>
      <slots-table
          :data="this.slots"
          :get-date-and-month="this.getDateAndMonth"
          :get-time="this.getTime"
      />
    </div>
    <div class="conf-container desktop-hide">
      <p class="text-20 fw-700 text-left">{{'Booking details' | translate}}</p>
      <slots-table-mobile
          :data="this.slots"
          :get-date-and-month="this.getDateAndMonth"
          :get-time="this.getTime"
      />
    </div>
    <div class="conf-container mobile-hide">
      <p class="text-20 fw-700">{{'Therapist' | translate}}</p>
      <therapist-table
          :data="this.therapist"
      />
    </div>
    <div class="conf-container desktop-hide">
      <p class="text-20 fw-700 text-left">{{'Therapist' | translate}}</p>
      <therapist-table-mobile
          :data="this.therapist"
      />
    </div>
  </div>
</template>

<script>
  import moment from 'moment';
  import SlotsTable from "./SlotsTable.vue";
  import SlotsTableMobile from "./SlotsTableMobile.vue";
  import TherapistTable from "./TherapistTable.vue";
  import TherapistTableMobile from "./TherapistTableMobile.vue";

  export default {
    name: 'ConfirmReservation',
    components: { SlotsTable, SlotsTableMobile, TherapistTable, TherapistTableMobile },
    props: {
      customerEmail: {
        type: String,
      },
      slots: {
        type: Array,
      },
      therapist: {
        full_name: String,
        phone: String,
        email: String,
        address: String,
      },
    },
    methods: {
      getDateAndMonth(date) {
        return moment.utc(date).format('D MMMM');
      },
      getTime(date) {
        return moment.utc(date).tz('Europe/Zurich').format('HH:mm');
      },
    },
    computed: {
      confirmationTitle() {
        const full_name = this.therapist.full_name;
        let title = `Your reservation with {0} has been successfully confirmed!`;
        return this.$options.filters.translate(title, [full_name]);
      },
      emailTitle() {
        const email = this.customerEmail;
        let title = `An email containing your booking details has been sent to {0}.`;
        return this.$options.filters.translate(title, [email]);
      },
    }
  }
</script>
<style lang="less">
.text-left {
  text-align: left;
}
.gap-12 {
  gap: 12px;
}
.conf-header {
  padding: 32px;
  background-color: rgba(73, 214, 223, 0.1);
  gap: 24px;
  &__icon {
    width: 48px;
    height: 48px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: rgba(73, 214, 223, 1);
    border-radius: 50%;
  }
}
.conf-container {
  display: flex;
  width: 100%;
  gap: 24px;
  flex-direction: column;
}
.conf-footer {
  padding: 24px 0;
  justify-content: flex-end;
}
</style>



// WEBPACK FOOTER //
// src/components/tbooking-widget/ConfirmReservation.vue